import { NgModule } from "@angular/core";
import { AppManagerComponent } from "./appManager/appManager.component";
import { ResizableDirective } from "./directives/resizable.directive";

@NgModule({
  imports: [

  ],
  declarations: [
    AppManagerComponent,
    ResizableDirective
  ],
  exports: [
    AppManagerComponent,
    ResizableDirective
  ]
})
export class ShareModules { }